import MicroModal from 'micromodal';

export default function mobileMenu () {

    const bodyCssClass = 'menu-open';

    const Selector = {
        MENU_OPEN: '[data-micromodal-trigger]',
        MENU_CONTAINER: 'menu-modal',
    }

    const element = {
        MENU_OPEN: document.querySelectorAll(Selector.MENU_OPEN),
        MENU_CONTAINER: document.getElementById(Selector.MENU_CONTAINER),
    }

    function init () {
        if(element.MENU_CONTAINER) {
            window.menuModal = {
                init: MicroModal.init({
                    onShow: modal => onShowActions(modal),
                    onClose: modal => onCloseActions(modal),
                }),
                show: MicroModal.show,
                close: MicroModal.close,
            };

            const links = element.MENU_CONTAINER.querySelectorAll('a[href^="#"]');

            links.forEach((element => {
                element.addEventListener('click', () => {
                    window.menuModal.close(Selector.MENU_CONTAINER);
                    document.body.classList.remove(bodyCssClass);
                })
            }));

            document.addEventListener('click', (e) => {
                if (!e.target.closest(Selector.MENU_OPEN) && !e.target.closest('#'+Selector.MENU_CONTAINER)) {
                    //window.menuModal.close(Selector.MENU_CONTAINER);
                }
            });
        }
    }

    function onCloseActions (modal) {
        modal.setAttribute("inert", true);
        document.body.classList.remove(bodyCssClass);
    }

    function onShowActions (modal) {
        modal.removeAttribute("inert");
        const closeBtn = modal.querySelector("[data-menu-close]");
        if(closeBtn) {
            modal.querySelector("[data-menu-close]").focus();
        }
        document.body.classList.add(bodyCssClass);
    }

    init();
}